import { useMutation } from '@tanstack/react-query';
import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index';
import { NAVIGATION_STACK_VERSION } from '@Types/consts';
import { OnboardingFlowIdentifier } from '@Types/onboarding.types';
import { routesModel } from './router.consts';
import type { RoutesMap } from './router.types';
interface IUpdateNavStack {
  currentPage: RoutesMap;
  force?: boolean;
  stepToReturn?: RoutesMap;
}
export const useUpdateCustomerHomeAddress = (onSuccess: () => void) => {
  return useMutation({
    mutationFn: (props: IUpdateNavStack) => updateNavStack(props),
    mutationKey: ['useUpdateCustomerHomeAddress'],
    onSuccess: () => onSuccess(),
  });
};

export const updateNavStack = async (props: IUpdateNavStack) => {
  const {
    navigationStack,
    getIsEmbedded,
    onboardingFlowIdentifier,
    authorizedUserId,
    customerId: authCustomerId,
  } = useBoundStore.getState().onboardingSlice;
  const { customerId } = useBoundStore.getState().customer;

  let url: string;
  if (onboardingFlowIdentifier === OnboardingFlowIdentifier.AUTHORIZED_USER) {
    if (!authCustomerId || !authorizedUserId) return;
    url = `/v3/onboarding/user/${authCustomerId}/authorized/user/${authorizedUserId}/step`;
  } else {
    if (!customerId) return;
    url = getIsEmbedded()
      ? `/v4/secureonboarding/partner/user/${customerId}/step`
      : `/v4/secureonboarding/user/${customerId}/step`;
  }

  if (props.force) {
    url = `${url}?force=true`;
  }
  await HttpService.post(url, {
    name: routesModel[props.currentPage as keyof typeof routesModel].id,
    version: NAVIGATION_STACK_VERSION,
    availableSteps: navigationStack,
    stepToReturn: props.stepToReturn,
  });
};
